function onFirstUserInteraction() {
  if (typeof swiperHeroBanner !== "undefined" && swiperHeroBanner) {
    if (swiperHeroBanner.params && swiperHeroBanner.autoplay) {
      let dataDelay = document
        .querySelector("[data-hero]")
        .getAttribute("data-delay");
      swiperHeroBanner.params.autoplay.delay = dataDelay
        ? parseInt(dataDelay) * 1000
        : 5000;
      if (typeof swiperHeroBanner.update === "function") {
        swiperHeroBanner.update();
      }
      if (typeof swiperHeroBanner.autoplay.start === "function") {
        swiperHeroBanner.autoplay.start();
      }
    }
  }
}

function addFirstInteractionListener() {
  var triggered = false;
  function handler() {
    if (!triggered) {
      triggered = true;
      onFirstUserInteraction();
      document.removeEventListener("click", handler);
      document.removeEventListener("keydown", handler);
      document.removeEventListener("touchstart", handler);
      window.removeEventListener("scroll", handler);
    }
  }
  document.addEventListener("click", handler);
  document.addEventListener("keydown", handler);
  document.addEventListener("touchstart", handler);
  window.addEventListener("scroll", handler);
}

window.addEventListener("load", function () {
  addFirstInteractionListener();
});
